import React from 'react'
import DataTable from '../Shared/DataTable/DataTable.js'
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import ItemDetailsPane from './ItemDetailsPane.js'

const CountryRegistrationsDocuments = ({ embedInSubmissions = false, actionMethodForSubmissions = null, hideHeader = false, hideTitle = false, hideBreadcrumbs = false, allSubmissionFilesIds = [], filterDocType = null }) => {

    let dataTableStructure = {};

    dataTableStructure.dataUrl = "/umbraco/api/ProductRegistrationsApi/Documents";
    dataTableStructure.getSingleItemUrl = "/umbraco/api/ProductRegistrationsApi/Documents";
    dataTableStructure.pageTitle = "Files";
    dataTableStructure.singleItemTitle = "Document";
    dataTableStructure.entityType = "country-registration-documents";
    dataTableStructure.pageIcon = "fas fa-file-pdf";
    dataTableStructure.breadcrumbs = [{ "Name": "Country Registrations", "Link": "/your-medboard/country-registrations/" }, { "Name": "Documents", "Link": "/your-medboard/country-registrations/documents/" }]
    dataTableStructure.dataStructure = [];
    dataTableStructure.hideAddButton = true;
    dataTableStructure.embedInSubmissions = embedInSubmissions;
    dataTableStructure.actionMethodForSubmissions = actionMethodForSubmissions;
    dataTableStructure.hideHeader = hideHeader;
    dataTableStructure.hideTitle = hideTitle;
    dataTableStructure.hideBreadcrumbs = hideBreadcrumbs;
    dataTableStructure.filterDocType = filterDocType;
    dataTableStructure.reachedAllowance = window.reachedAllowanceRegulatoryDocuments ? window.reachedAllowanceRegulatoryDocuments : false;
    dataTableStructure.disableRowClicks = true;
    dataTableStructure.showListTotalCount = true;
    dataTableStructure.listTotalCountURL = "/umbraco/api/ProductRegistrationsApi/DocumentsCount/";

    let colSizes = {
        Filename: "35%",
        LinkedToEntity: "25%",
        CountryName: "20%",
        UploadDate: "10%",
        UploadedBy: "10%",
    };

    if (embedInSubmissions) {
        colSizes = {
            Filename: "30%",
            LinkedToEntity: "25%",
            CountryName: "20%",
            UploadDate: "10%",
            UploadedBy: "10%",
            CertificateFileId: "5%",
        };
    }




    dataTableStructure.dataStructure.push({ name: "File Name", field: "Filename", width: colSizes.Filename, sortable: true, disableRowClick: true, renderWith: FieldTypes.FieldType_DocumentLinkWithName, isMultiField: ["Filename", "FileUrl"] });
    dataTableStructure.dataStructure.push({ name: "Linked to", field: "LinkedToEntity", width: colSizes.LinkedToEntity, sortable: true, disableRowClick: true, renderWith: FieldTypes.FieldType_DocumentLink, isMultiField: ["LinkedToEntity", "EntityUrl", "EntityType"] });
    dataTableStructure.dataStructure.push({ name: "Country", field: "CountryName", width: colSizes.CountryName, sortable: true, disableRowClick: true, renderWith: FieldTypes.FieldType_Country, isMultiField: ["CountryName", "CountryUrl", "FlagLink"] });
    //dataTableStructure.dataStructure.push({ name: "Certificate", field: "CertificateName", width: "20%", sortable: true, disableRowClick: true, renderWith: FieldTypes.FieldType_DocumentLink, isMultiField: ["OperatorName", "CertificateName", "EntityUrl", "EntityType"] });
    //dataTableStructure.dataStructure.push({ name: "Operator", field: "OperatorName", width: "20%", sortable: true, disableRowClick: true, renderWith: FieldTypes.FieldType_DocumentLink, isMultiField: ["OperatorName", "EntityUrl", "EntityType"] });
    dataTableStructure.dataStructure.push({ name: "Uploaded On", field: "UploadDate", width: colSizes.UploadDate, sortable: true, disableRowClick: true, renderWith: FieldTypes.FieldType_DateList });
    dataTableStructure.dataStructure.push({ name: "Uploaded By", field: "UploadedBy", width: colSizes.UploadedBy, sortable: true, disableRowClick: true, renderWith: FieldTypes.FieldType_User });


    // The documents list in embedded in the Submissions project
    if (embedInSubmissions)
        dataTableStructure.dataStructure.push({ name: "Actions", field: "CertificateFileId", width: colSizes.CertificateFileId, sortable: false, disableRowClick: true, renderWith: FieldTypes.LinkFileToSubmission, isMultiField: [ "CertificateFileId", "FileKey", { allSubmissionFilesIds: allSubmissionFilesIds }] });


    dataTableStructure.dataUrlParameters = { search: null, page: 1, orderByField: "Name", orderByType: "ASCENDING" }


    return (<>

        <DataTable dataTableStructure={dataTableStructure} ItemDetailsPane={ItemDetailsPane} />

    </>);

};



export default CountryRegistrationsDocuments;